import { render, staticRenderFns } from "./CommissionField.vue?vue&type=template&id=ae68f8f4"
import script from "./CommissionField.vue?vue&type=script&lang=js"
export * from "./CommissionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports